import { Location, NgClass, NgFor, NgIf } from '@angular/common';
import {
  Component,
  ElementRef,
  Input,
  OnChanges,
  OnDestroy,
  QueryList,
  Renderer2,
  SimpleChanges,
  ViewChildren,
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Params, Router, RouterModule } from '@angular/router';
import { DynamicModule } from 'ng-dynamic-component';
import { CollectionItemComponent } from 'src/app/components/collection-item/collection-item.component';
import { PreventDefaultDirective } from 'src/app/directive/prevent-default.directive';
import { StoryblokDirective } from 'src/app/directive/storyblok.directive';
import { EnvironmentService } from 'src/app/service/environment.service';
import { MercuryService } from 'src/app/service/mercury.service';
import { StoryBlokService } from 'src/app/service/storyblok.service';
import { FilterAccordionComponent } from './components/filter-accordion/filter-accordion.component';

@Component({
  selector: 'app-mercury-collection',
  standalone: true,
  imports: [
    DynamicModule,
    StoryblokDirective,
    PreventDefaultDirective,
    NgIf,
    NgFor,
    CollectionItemComponent,
    RouterModule,
    FilterAccordionComponent,
    NgClass,
  ],
  templateUrl: './mercury-collection.component.html',
  styleUrl: './mercury-collection.component.scss',
})
export class ContentSourceMercuryCollectionComponent
  implements OnChanges, OnDestroy
{
  collection: any;
  facets: any;
  story: any;
  @Input() _editable!: string;
  @ViewChildren('child') children!: QueryList<ElementRef>;
  components: any;
  config: any;
  active: any;
  _toggleFilters: boolean = false;
  _moreContent: any;
  _additionalText: any;
  _show: boolean = false;
  _links: any[] = [];
  _handle: string = '';
  parseInt = parseInt;
  pageNo: number = 1;
  pageNoNext = this.pageNo + 1;
  currentBreakpoint: any;
  constructor(
    private storyBlokService: StoryBlokService,
    private mercuryService: MercuryService,
    private environmentService: EnvironmentService,
    private route: ActivatedRoute,
    private router: Router,
    private renderer: Renderer2,
    private domSanitizer: DomSanitizer,
    private location: Location
  ) {
    this.mercuryService.configObservable.subscribe((data) => {
      this.config = data;
    });
    this.mercuryService.facetObservable.subscribe((data) => {
      this.facets = data;
    });
    this.mercuryService.selectedObservable.subscribe((data) => {
      this.active = data;
    });
    this.route.queryParams.subscribe((data) => {
      this.mercuryService.filters = data;
      if (data.page !== undefined) {
        this.pageNo = parseInt(data.page);
      }
    });
    import('src/app/storyblok/components').then((cp) => {
      this.components = cp.Components;
    });
    this.route.data.subscribe((data) => {
      this.collection = data.collection;

      try {
        for (let item of this.collection?.campaign?.blocks || []) {
          this.constructHTML(item);
        }
      } catch (err) {
        console.log(err);
      }

      this.ngOnChanges({});
    });
  }

  async ngOnChanges(changes: SimpleChanges) {
    if (this._handle == this.collection?.handle) {
      return;
    }
    this._moreContent = this.collection?.metafields?.MERCURY?.readmore
      ? true
      : false;
    this._additionalText = this.domSanitizer.bypassSecurityTrustHtml(
      this.collection.metafields?.MERCURY?.readmore || ''
    );
    this._handle = this.collection.handle;
    this.story = undefined;
    this.story = await this.storyBlokService
      .getStory(
        this.collection?.metafields?.storyblok?.uid ||
          'collections/' + this.collection?.handle,
        {}
      )
      .then((data) => data.story)
      .catch((err) => {
        console.log(err);
      });

    this._show = false;
    if (this.collection) {
      this._links = [];
      for (let i = 1; i <= 4; i++) {
        const handleKey = `collection_${i}_handle`;
        const linkKey = `collection_${i}_link`;

        if (
          this.collection.metafields?.custom &&
          this.collection.metafields?.custom[handleKey] &&
          this.collection.metafields?.custom[linkKey]
        ) {
          this._links[i - 1] = {
            handle: this.collection.metafields.custom[handleKey],
            title: this.collection.metafields.custom[linkKey],
          };
        }
      }

      this._moreContent = this.collection?.metafields?.MERCURY?.readmore
        ? true
        : false;
      this._additionalText = this.domSanitizer.bypassSecurityTrustHtml(
        this.collection.metafields?.MERCURY?.readmore || ''
      );
    }
  }

  clearAll() {
    this.mercuryService.clearFilters();
  }

  async loadMore() {
    this.pageNo++;
    let params = structuredClone(this.mercuryService.filters);
    params['page'] = this.pageNo;
    const queryParams: Params = { ...this.route.snapshot.queryParams };
    queryParams['page'] = this.pageNo;
    const currentUrl = this.router.url.split('?')[0];
    const newUrl = `${currentUrl}?${new URLSearchParams(
      queryParams as any
    ).toString()}`;
    this.location.go(newUrl);

    await this.mercuryService
      .getFilteredCollection(
        this.collection.handle,
        this.mercuryService.calculateFilters(params),
        params?.sort || '',
        20,
        params?.page ? (params.page - 1) * 20 : 0
      )
      .toPromise()
      .then((result: any) => {
        this.collection.products = this.collection.products.concat(
          result.products
        );
      });
  }

  ngOnDestroy(): void {
    this.renderer.setStyle(
      this.environmentService.getWindow()?.document.body,
      'overflow',
      'auto'
    );
  }

  toggleFilters() {
    this._toggleFilters = !this._toggleFilters;
    if (this._toggleFilters) {
      this.renderer.setStyle(
        this.environmentService.getWindow()?.document.body,
        'overflow',
        'hidden'
      );
    } else {
      this.renderer.setStyle(
        this.environmentService.getWindow()?.document.body,
        'overflow',
        'auto'
      );
    }
  }

  constructHTML(block: any) {
    block._classes = [
      ...block.sizes.map((x: any, index: number) => {
        let result = '';
        let breakpoint = this.config.grid.breakpoints.find(
          (x: any) => x.index == index
        );

        if (index == 0) {
          result += ' order-' + (x.index + 1);
          result += ' g-col-' + x.colSpan * (12 / breakpoint.columns);
        }
        if (index == 1) {
          result += ' order-md-' + (x.index + 1);
          result += ' g-col-md-' + x.colSpan * (12 / breakpoint.columns);
        }
        if (index == 2) {
          result += ' order-lg-' + (x.index + 1);
          result += ' g-col-lg-' + x.colSpan * (12 / breakpoint.columns);
        }
        return result;
      }),
      ,
    ].join(' ');
    let content;
    try {
      content = JSON.parse(block.content);
    } catch (err) {
      return;
    }

    let element = this.renderer.createElement(
      content?.link?.href ? 'a' : 'div'
    );
    if (content.link) {
      this.renderer.setAttribute(element, 'href', content.link.href);
    }
    this.renderer.addClass(element, 'h-100');
    this.renderer.addClass(element, 'w-100');
    this.renderer.addClass(element, 'd-flex');
    this.renderer.setStyle(element, 'background', content.styles.background);
    this.renderer.setStyle(
      element,
      'backgroundImage',
      'url(' + content.styles.backgroundImage + ')'
    );
    this.renderer.setStyle(
      element,
      'backgroundSize',
      content.styles.backgroundSize
    );
    this.renderer.setStyle(element, 'backgroundRepeat', 'no-repeat');
    this.renderer.setStyle(
      element,
      'backgroundPosition',
      content.styles.backgroundPosition
    );
    //console.log('running');

    try {
      setTimeout(() => {
        this.renderer.appendChild(
          this.children.find((x) => x.nativeElement.id === block.id)
            ?.nativeElement,
          element
        );
      }, 30);
    } catch (err) {
      console.log(err);
    }
  }

  recursivelyCreateElements(element: any, entry: any) {
    // for (let child of entry.entries) {
    //   let childElement = document.createElement('div');
    //   if (child.extras) {
    //     if (child.extras.justify || child.extras.align)
    //       childElement.classList.add('d-flex');
    //     if (child.extras.justify)
    //       childElement.classList.add('justify-content-' + child.extras.justify);
    //     if (child.extras.align)
    //       childElement.classList.add('align-items-' + child.extras.align);
    //   }
    //   if (child.type == 'content') {
    //     let grandChildElement = document.createElement(child.subtype);
    //     grandChildElement.classList.add('flex-row');
    //     grandChildElement.innerText = child.value;
    //     grandChildElement.style.color = child.styles.color;
    //     childElement.appendChild(grandChildElement);
    //   } else {
    //     childElement.classList.add('flex-column');
    //     childElement.classList.add('w-100');
    //   }
    //   element.appendChild(childElement);
    //   if (child?.entries?.length > 0) {
    //     this.recursivelyCreateElements(childElement, child);
    //   }
    // }
  }
}
